export const SET_ORGANISATION = 'SET_ORGANISATION';

export function setOrganisation(organisation) {
  return {
    type: SET_ORGANISATION,
    organisation
  };
}
